export default __webpack_public_path__ + "static/media/title-img.471c2dc5.svg";